import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect } from 'react';
import * as microsoftTeams from '@microsoft/teams-js';
import './_CookiesNotSupported.scss';

var CookiesNotSupportedError = function CookiesNotSupportedError(props) {
  var _useState = useState('en-us'),
      _useState2 = _slicedToArray(_useState, 2),
      lang = _useState2[0],
      setLang = _useState2[1];

  useEffect(function () {
    microsoftTeams.app.getContext().then(function (context) {
      if (context == null || context.app.locale == null) {
        return false;
      }

      if (context.app.locale == 'sv-se') {
        setLang('sv-se');
      }
    });
  }, []);

  if (lang == 'sv-se') {
    return /*#__PURE__*/React.createElement("div", {
      className: "cookies-not-supported container"
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        minHeight: '15rem',
        width: '15rem',
        marginBottom: '3rem'
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: "/dist/svg/illustration_fel-404.svg"
    })), /*#__PURE__*/React.createElement("h1", null, "Oj, n\xE5got gick fel!"), /*#__PURE__*/React.createElement("p", {
      style: {
        marginTop: '1rem'
      }
    }, "Om du vill anv\xE4nda Haldor Education m\xE5ste du \xE4ndra inst\xE4llningarna i din webbl\xE4sare s\xE5 den till\xE5ter cookies fr\xE5n tredje part. Om du beh\xF6ver hj\xE4lp, ta kontakt med din skolas IT-support.", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), "Om din skola har blockerat tredjepartcookies f\xF6r hela organisationen m\xE5ste er IT-support l\xE4gga till ", /*#__PURE__*/React.createElement("strong", null, "[*.]haldor.se"), " som en till\xE5ten webbplats.", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("h3", {
      style: {
        marginBottom: '.65rem'
      }
    }, "Anv\xE4nder du Microsoft Teams i webbl\xE4saren?"), "Om du anv\xE4nder Microsoft Teams och Haldors tj\xE4nster i webbl\xE4saren m\xE5ste du ocks\xE5 l\xE4gga till webbplatserna f\xF6r Microsoft Teams som till\xE5tna webbplatser. Du hittar\xA0", /*#__PURE__*/React.createElement("a", {
      href: "https://docs.microsoft.com/sv-se/microsoftteams/troubleshoot/teams-sign-in/sign-in-loop",
      target: "_blank"
    }, "alla webbplatser i Microsofts guide.")));
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "cookies-not-supported container"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      minHeight: '15rem',
      width: '15rem',
      marginBottom: '3rem'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "/dist/svg/illustration_fel-404.svg"
  })), /*#__PURE__*/React.createElement("h1", null, "Whoops, something went wrong!"), /*#__PURE__*/React.createElement("p", {
    style: {
      marginTop: '1rem'
    }
  }, "You need to change your browser settings to allow third-party cookies to use Haldor Education. If you need help, contact your school's IT-support.", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), "If your school has disabled third-party cookies for the entire organization your IT-support needs to add ", /*#__PURE__*/React.createElement("strong", null, "[*.]haldor.se"), " as a trusted site.", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("h3", {
    style: {
      marginBottom: '.65rem'
    }
  }, "Using Microsoft Teams in your browser?"), "If you are using Microsoft Teams and Haldor\u2019s services in a desktop browser, you also need to add the URLs for Microsoft Teams as trusted sites. You can find\xA0", /*#__PURE__*/React.createElement("a", {
    href: "https://docs.microsoft.com/en-us/microsoftteams/troubleshoot/teams-sign-in/sign-in-loop#resolution",
    target: "_blank"
  }, "all the URLs in Microsoft\u2019s guide.")));
};

export default CookiesNotSupportedError;